//#region src/client/client-error.ts
/**
* Base error class for all Fragno client errors.
*/
var FragnoClientError = class extends Error {
	#code;
	constructor(message, code, options = {}) {
		super(message, { cause: options.cause });
		this.name = "FragnoClientError";
		this.#code = code;
	}
	get code() {
		return this.#code;
	}
};
var FragnoClientFetchError = class extends FragnoClientError {
	constructor(message, code, options = {}) {
		super(message, code, options);
		this.name = "FragnoClientFetchError";
	}
	static fromUnknownFetchError(error) {
		if (!(error instanceof Error)) return new FragnoClientFetchNetworkError("Network request failed", { cause: error });
		if (error.name === "AbortError") return new FragnoClientFetchAbortError("Request was aborted", { cause: error });
		return new FragnoClientFetchNetworkError("Network request failed", { cause: error });
	}
};
/**
* Error thrown when a network request fails (e.g., no internet connection, DNS failure).
*/
var FragnoClientFetchNetworkError = class extends FragnoClientFetchError {
	constructor(message = "Network request failed", options = {}) {
		super(message, "NETWORK_ERROR", options);
		this.name = "FragnoClientFetchNetworkError";
	}
};
/**
* Error thrown when a request is aborted (e.g., user cancels request, timeout).
*/
var FragnoClientFetchAbortError = class extends FragnoClientFetchError {
	constructor(message = "Request was aborted", options = {}) {
		super(message, "ABORT_ERROR", options);
		this.name = "FragnoClientFetchAbortError";
	}
};
/**
* Error thrown when the API result is unexpected, e.g. no json is returned.
*/
var FragnoClientUnknownApiError = class extends FragnoClientError {
	#status;
	constructor(message = "Unknown API error", status, options = {}) {
		super(message, "UNKNOWN_API_ERROR", options);
		this.name = "FragnoClientUnknownApiError";
		this.#status = status;
	}
	get status() {
		return this.#status;
	}
};
var FragnoClientApiError = class FragnoClientApiError extends FragnoClientError {
	#status;
	constructor({ message, code }, status, options = {}) {
		super(message, code, options);
		this.name = "FragnoClientApiError";
		this.#status = status;
	}
	get status() {
		return this.#status;
	}
	/**
	* The error code returned by the API.
	*
	* The type is `TErrorCode` (the set of known error codes for this route), but may also be a string
	* for forward compatibility with future error codes.
	*/
	get code() {
		return super.code;
	}
	static async fromResponse(response) {
		const unknown = await response.json();
		const status = response.status;
		if (!("message" in unknown || "code" in unknown)) return new FragnoClientUnknownApiError("Unknown API error", status);
		if (!(typeof unknown.message === "string" && typeof unknown.code === "string")) return new FragnoClientUnknownApiError("Unknown API error", status);
		return new FragnoClientApiError({
			message: unknown.message,
			code: unknown.code
		}, status);
	}
};

//#endregion
export { FragnoClientApiError, FragnoClientError, FragnoClientFetchAbortError, FragnoClientFetchError, FragnoClientFetchNetworkError, FragnoClientUnknownApiError };
//# sourceMappingURL=client-error.js.map